import PropTypes from 'prop-types';

import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  listItemIcon: {
    minWidth: '32px',
  },
});

const VerifiedDataList = ({ userName, licenceVerified, phoneVerified, classes }) => (
  <Box display="flex" flexDirection="column">
    <Typography paragraph variant="h5" style={{ wordBreak: 'break-word' }}>
      {userName} confirmed
    </Typography>

    <List dense disablePadding>
      <ListItem dense disableGutters>
        <ListItemIcon classes={{ root: classes.listItemIcon }}>
          {licenceVerified ? <CheckOutlinedIcon /> : <CloseOutlinedIcon />}
        </ListItemIcon>
        <ListItemText primary="Driver licence" />
      </ListItem>

      <ListItem dense disableGutters>
        <ListItemIcon classes={{ root: classes.listItemIcon }}>
          {phoneVerified ? <CheckOutlinedIcon /> : <CloseOutlinedIcon />}
        </ListItemIcon>
        <ListItemText primary="Phone number" />
      </ListItem>
    </List>
  </Box>
);

VerifiedDataList.propTypes = {
  userName: PropTypes.string,
  licenceVerified: PropTypes.bool,
  phoneVerified: PropTypes.bool,
  classes: PropTypes.shape({
    listItemIcon: PropTypes.string.isRequired,
  }).isRequired,
};

VerifiedDataList.defaultProps = {
  userName: '',
  licenceVerified: false,
  phoneVerified: false,
};

export default withStyles(styles)(VerifiedDataList);
